<template>
  <div class="text-left">
    <h5 class="text-center">
      <strong>{{ $t("name") }}:</strong> {{ title }}
      <span class="ml-5" v-if="supervisor"
        ><strong> Supervisor:</strong> {{ supervisor.username }}</span
      >
    </h5>
    <v-divider />
    <form>
      <v-row>
        <v-col cols="12" md="6">
          <v-combobox
            v-model="categorySelected"
            :items="categories"
            item-text="internal_name"
            :label="$t('label.category')"
            return-object
            outlined
            readonly
          ></v-combobox>
        </v-col>
        <v-col cols="12" md="6">
          <v-select
            v-model="investigator.vinculation.type"
            :items="vinculationTypes"
            item-value="value"
            item-text="text"
            :label="$t('type')"
            outlined
            readonly
          ></v-select
        ></v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model="investigator.vinculation.start_date"
            :label="$t('label.startDate')"
            prepend-inner-icon="event"
            readonly
            hide-details
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="investigator.vinculation.end_date"
            :label="$t('label.endDate')"
            prepend-inner-icon="event"
            readonly
            hide-details
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-checkbox
              :label="$t('form.add.expiration_date')"
              v-model="extend_expiration_date"
              readonly
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-checkbox
              :label="$t('form.add.workplace_date')"
              v-model="extend_workplace_assignation_date"
              readonly
          />
        </v-col>
      </v-row>
      <v-divider />
      <DirectorActions v-if="isAuthorize" :object_type="object_type" />
      <SupervisorActions
        v-else
        :item="investigator"
        :object_type="object_type"
        :form_name="form_name"
        :state="state"
        :supervisor="supervisor !== null ? supervisor.username : ''"
        @change-state-supervisor="onStateSupervisorChange"
      />
    </form>
  </div>
</template>

<script>
import axios from "axios";
import DirectorActions from "../../action_buttons/DirectorActions";
import SupervisorActions from "../../action_buttons/SupervisorActions";
import investigatorData from "../../../mixins/investigator_data";
import investigator_model from "../../../mixins/model_utils/investigator_model";

export default {
  mixins: [investigatorData, investigator_model],
  components: { DirectorActions, SupervisorActions },

  data: () => ({
    object_type: "",
    categorySelected: "",
    supervisor: "",
    title: "",
    form_name: "",
    state: "",
    reject_comment: "",
    extend_expiration_date: true,
    extend_workplace_assignation_date: true
  }),

  created() {
    this.getCategories();
    this.getVinculationTypes();
    this.getData();
  },

  computed: {
    isAuthorize() {
      return this.$route.meta.authorize !== undefined;
    }
  },

  methods: {
    getData() {
      let path;
      if (this.isAuthorize) {
        path =
          this.$store.state.endpoint +
          "/direction/moderatedOperations/authorize/investigator/" +
          this.$route.params.id;
      } else {
        path =
          this.$store.state.endpoint +
          "/moderatedOperations/review/investigator/" +
          this.$route.params.id;
      }

      axios
        .get(path)
        .then(response => {
          this.investigator.vinculation = response.data.data.user.vinculation;
          this.extend_expiration_date = response.data.data.user.extend_expiration_date;
          this.extend_workplace_assignation_date = response.data.data.user.extend_workplace_assignation_date;
          this.reject_comment = response.data.reject_comment;
          this.form_name = response.data.form_name;
          this.title = response.data.title;
          this.state = response.data.state;
          this.supervisor = response.data.supervisor;
          this.object_type = response.data.object_type;
          this.investigator.id = response.data.object_id;
          this.getInvestigatorName(
            this.$store.state.endpoint + "/person/" + this.investigator.id
          );
          this.loadCategorySelected(this.investigator.vinculation.category);
        })
        .catch(error => {
          console.log(error);
        });
    },

    loadCategorySelected(item) {
      if (typeof item == "number") {
        this.categorySelected = this.categories.filter(
          category => category.id === item
        )[0];
      } else {
        this.categorySelected = item;
      }
    },

    onStateSupervisorChange(state, supervisor) {
      this.state = state;
      this.supervisor = supervisor;
    }
  }
};
</script>
